module.exports = __webpack_public_path__ + "static/media/item-11.d1ebea4a.png";